import api from '../../services/api';
import {
  GET_REPAIR_ORDERS_REQUEST,
  GET_REPAIR_ORDERS_SUCCESS,
  GET_REPAIR_ORDERS_FAILURE,
  GET_REPAIR_ORDER_REQUEST,
  GET_REPAIR_ORDER_SUCCESS,
  GET_REPAIR_ORDER_FAILURE,
  CREATE_REPAIR_ORDER_REQUEST,
  CREATE_REPAIR_ORDER_SUCCESS,
  CREATE_REPAIR_ORDER_FAILURE,
  UPDATE_REPAIR_ORDER_REQUEST,
  UPDATE_REPAIR_ORDER_SUCCESS,
  UPDATE_REPAIR_ORDER_FAILURE,
  UPDATE_REPAIR_ORDER_STATUS_REQUEST,
  UPDATE_REPAIR_ORDER_STATUS_SUCCESS,
  UPDATE_REPAIR_ORDER_STATUS_FAILURE,
  ADD_REPAIR_ORDER_PAYMENT_REQUEST,
  ADD_REPAIR_ORDER_PAYMENT_SUCCESS,
  ADD_REPAIR_ORDER_PAYMENT_FAILURE,
  MARK_REPAIR_ORDER_DELIVERED_REQUEST,
  MARK_REPAIR_ORDER_DELIVERED_SUCCESS,
  MARK_REPAIR_ORDER_DELIVERED_FAILURE,
  GET_REPAIR_ORDER_PAYMENTS_REQUEST,
  GET_REPAIR_ORDER_PAYMENTS_SUCCESS,
  GET_REPAIR_ORDER_PAYMENTS_FAILURE,
  OUTSOURCE_REPAIR_ORDER_REQUEST,
  OUTSOURCE_REPAIR_ORDER_SUCCESS,
  OUTSOURCE_REPAIR_ORDER_FAILURE,
  MARK_REPAIR_ORDER_RECEIVED_REQUEST,
  MARK_REPAIR_ORDER_RECEIVED_SUCCESS,
  MARK_REPAIR_ORDER_RECEIVED_FAILURE,
  ADD_GOLDSMITH_PAYMENT_REQUEST,
  ADD_GOLDSMITH_PAYMENT_SUCCESS,
  ADD_GOLDSMITH_PAYMENT_FAILURE,
  GET_OUTSOURCE_TIMELINE_REQUEST,
  GET_OUTSOURCE_TIMELINE_SUCCESS,
  GET_OUTSOURCE_TIMELINE_FAILURE,
} from '../types';

// Get all repair orders
export const getRepairOrders = (filters = {}) => async (dispatch) => {
  try {
    dispatch({ type: GET_REPAIR_ORDERS_REQUEST });
    
    const queryParams = new URLSearchParams();
    if (filters.page) queryParams.append('page', filters.page);
    if (filters.limit) queryParams.append('limit', filters.limit);
    if (filters.status) queryParams.append('status', filters.status);
    if (filters.customerId) queryParams.append('customerId', filters.customerId);
    if (filters.startDate) queryParams.append('startDate', filters.startDate);
    if (filters.endDate) queryParams.append('endDate', filters.endDate);
    if (filters.search) queryParams.append('search', filters.search);
    
    const response = await api.get(`/repair-orders?${queryParams.toString()}`);
    
    dispatch({
      type: GET_REPAIR_ORDERS_SUCCESS,
      payload: response.data,
    });
    
    return { success: true, data: response.data };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to fetch repair orders';
    dispatch({
      type: GET_REPAIR_ORDERS_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};

// Get single repair order
export const getRepairOrder = (id) => async (dispatch) => {
  try {
    dispatch({ type: GET_REPAIR_ORDER_REQUEST });
    
    const response = await api.get(`/repair-orders/${id}`);
    
    dispatch({
      type: GET_REPAIR_ORDER_SUCCESS,
      payload: response.data,
    });
    
    return { success: true, data: response.data };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to fetch repair order';
    dispatch({
      type: GET_REPAIR_ORDER_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};

// Create repair order
export const createRepairOrder = (repairOrderData) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_REPAIR_ORDER_REQUEST });
    
    const response = await api.post('/repair-orders', repairOrderData);
    
    dispatch({
      type: CREATE_REPAIR_ORDER_SUCCESS,
      payload: response.data,
    });
    
    return { success: true, data: response.data };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to create repair order';
    dispatch({
      type: CREATE_REPAIR_ORDER_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};

// Update repair order
export const updateRepairOrder = (id, repairOrderData) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_REPAIR_ORDER_REQUEST });
    
    const response = await api.put(`/repair-orders/${id}`, repairOrderData);
    
    dispatch({
      type: UPDATE_REPAIR_ORDER_SUCCESS,
      payload: response.data,
    });
    
    return { success: true, data: response.data };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to update repair order';
    dispatch({
      type: UPDATE_REPAIR_ORDER_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};

// Update repair order status
export const updateRepairOrderStatus = (id, statusData) => async (dispatch) => {
  console.log('🔄 updateRepairOrderStatus ACTION STARTED');
  console.log('📋 Parameters:', { id, statusData });
  
  try {
    dispatch({ type: UPDATE_REPAIR_ORDER_STATUS_REQUEST });
    console.log('✅ Redux request action dispatched');
    
    const url = `/repair-orders/${id}/status`;
    console.log('🌐 Making API call to:', url);
    console.log('📤 Request data:', statusData);
    
    const response = await api.patch(url, statusData);
    console.log('📥 API response received:', response.data);
    
    dispatch({
      type: UPDATE_REPAIR_ORDER_STATUS_SUCCESS,
      payload: response.data,
    });
    console.log('✅ Redux success action dispatched');
    
    const result = { success: true, data: response.data };
    console.log('🎉 updateRepairOrderStatus ACTION COMPLETED SUCCESSFULLY');
    console.log('📋 Final result:', result);
    
    return result;
  } catch (error) {
    console.error('❌ updateRepairOrderStatus ACTION FAILED');
    console.error('🚨 Error details:', error);
    console.error('📥 Error response:', error.response?.data);
    console.error('🌐 Request URL:', error.config?.url);
    console.error('📤 Request data:', error.config?.data);
    
    const message = error.response?.data?.message || 'Failed to update repair order status';
    
    dispatch({
      type: UPDATE_REPAIR_ORDER_STATUS_FAILURE,
      payload: message,
    });
    console.log('❌ Redux failure action dispatched');
    
    const result = { success: false, message };
    console.log('📋 Error result:', result);
    
    return result;
  }
};

// Add payment to repair order
export const addRepairOrderPayment = (id, paymentData) => async (dispatch) => {
  try {
    dispatch({ type: ADD_REPAIR_ORDER_PAYMENT_REQUEST });
    
    const response = await api.post(`/repair-orders/${id}/payments`, paymentData);
    
    dispatch({
      type: ADD_REPAIR_ORDER_PAYMENT_SUCCESS,
      payload: response.data,
    });
    
    return { success: true, data: response.data };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to add payment';
    dispatch({
      type: ADD_REPAIR_ORDER_PAYMENT_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};

// Mark repair order as delivered
export const markRepairOrderDelivered = (id, deliveryData) => async (dispatch) => {
  try {
    dispatch({ type: MARK_REPAIR_ORDER_DELIVERED_REQUEST });
    
    console.log('=== REDUX DELIVERY DEBUG ===');
    console.log('API URL:', `/repair-orders/${id}/deliver`);
    console.log('Delivery Data:', deliveryData);
    console.log('============================');
    
    const response = await api.post(`/repair-orders/${id}/deliver`, deliveryData);
    
    console.log('API Response:', response.data);
    
    dispatch({
      type: MARK_REPAIR_ORDER_DELIVERED_SUCCESS,
      payload: response.data,
    });
    
    return { success: true, data: response.data };
  } catch (error) {
    console.error('Delivery API Error:', error);
    console.error('Error Response:', error.response?.data);
    const message = error.response?.data?.message || 'Failed to mark repair order as delivered';
    dispatch({
      type: MARK_REPAIR_ORDER_DELIVERED_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};

// Get repair order payments
export const getRepairOrderPayments = (filters = {}) => async (dispatch) => {
  try {
    dispatch({ type: GET_REPAIR_ORDER_PAYMENTS_REQUEST });
    
    const queryParams = new URLSearchParams();
    if (filters.page) queryParams.append('page', filters.page);
    if (filters.limit) queryParams.append('limit', filters.limit);
    if (filters.paymentModeId) queryParams.append('paymentModeId', filters.paymentModeId);
    if (filters.startDate) queryParams.append('startDate', filters.startDate);
    if (filters.endDate) queryParams.append('endDate', filters.endDate);
    
    console.log('=== REPAIR ORDER PAYMENTS ACTION DEBUG ===');
    console.log('Making API call to /repair-orders/payments/list with query:', queryParams.toString());
    
    const response = await api.get(`/repair-orders/payments/list?${queryParams.toString()}`);
    
    console.log('API response:', response.data);
    console.log('Response data:', response.data.data);
    console.log('Response payments:', response.data.data?.payments);
    console.log('Response payments length:', response.data.data?.payments?.length);
    console.log('==========================================');
    
    dispatch({
      type: GET_REPAIR_ORDER_PAYMENTS_SUCCESS,
      payload: response.data,
    });
    
    return { success: true, data: response.data };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to fetch repair order payments';
    dispatch({
      type: GET_REPAIR_ORDER_PAYMENTS_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};

// Outsource repair order to goldsmith
export const outsourceRepairOrder = (id, outsourceData) => async (dispatch) => {
  try {
    dispatch({ type: OUTSOURCE_REPAIR_ORDER_REQUEST });
    
    const response = await api.post(`/repair-orders/${id}/outsource`, outsourceData);
    
    dispatch({
      type: OUTSOURCE_REPAIR_ORDER_SUCCESS,
      payload: response.data,
    });
    
    return { success: true, data: response.data };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to outsource repair order';
    dispatch({
      type: OUTSOURCE_REPAIR_ORDER_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};

// Mark repair order as received from goldsmith
export const markRepairOrderReceived = (id, receivedData) => async (dispatch) => {
  try {
    dispatch({ type: MARK_REPAIR_ORDER_RECEIVED_REQUEST });
    
    const response = await api.post(`/repair-orders/${id}/received`, receivedData);
    
    dispatch({
      type: MARK_REPAIR_ORDER_RECEIVED_SUCCESS,
      payload: response.data,
    });
    
    return { success: true, data: response.data };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to mark repair order as received';
    dispatch({
      type: MARK_REPAIR_ORDER_RECEIVED_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};

// Add payment to goldsmith
export const addGoldsmithPayment = (id, paymentData) => async (dispatch) => {
  try {
    dispatch({ type: ADD_GOLDSMITH_PAYMENT_REQUEST });
    
    const response = await api.post(`/repair-orders/${id}/goldsmith-payments`, paymentData);
    
    dispatch({
      type: ADD_GOLDSMITH_PAYMENT_SUCCESS,
      payload: response.data,
    });
    
    return { success: true, data: response.data };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to add goldsmith payment';
    dispatch({
      type: ADD_GOLDSMITH_PAYMENT_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};

// Get outsource timeline
export const getOutsourceTimeline = (id) => async (dispatch) => {
  try {
    dispatch({ type: GET_OUTSOURCE_TIMELINE_REQUEST });
    
    const response = await api.get(`/repair-orders/${id}/outsource-timeline`);
    
    dispatch({
      type: GET_OUTSOURCE_TIMELINE_SUCCESS,
      payload: response.data,
    });
    
    return { success: true, data: response.data };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to fetch outsource timeline';
    dispatch({
      type: GET_OUTSOURCE_TIMELINE_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};

